/* eslint-disable jira/filename-case */
/** Same prefix as store.js namespaced keys: `__storejs_` + namespace + `_` + key */
export const STOREJS_KEY_PREFIX = '__storejs_';

export const NAMESPACE = 'timestamps';

export const ONE_WEEK: number = 1000 * 60 * 60 * 24 * 7;
export const FOUR_WEEKS: number = 4 * ONE_WEEK;

export const LOCAL_STORAGE_FULL_ERROR_CODE = 22;
export const LOCAL_STORAGE_FULL_FF_ERROR_CODE = 1014;
